import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input, OnInit,
  Renderer2
} from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-accordion',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ds-accordion.component.html',
    styleUrls: ['./ds-accordion.component.scss'],
    standalone: false
})
export class DsAccordionComponent implements OnInit {

  @Input() bgColor: string = 'red';
  @Input() title: string;
  @Input() body: any;
  @Input() height: number = 36;
  @Input() img?: string;

  public toggled: boolean;

  constructor(
    private _element: ElementRef,
    private _renderer: Renderer2
  ) {
  }

  ngOnInit() {
    this._element && this._renderer.setStyle(this._element.nativeElement, 'max-height', this.height + 'px');
  }

  public toggle(): void {
    this.toggled = !this.toggled;
    this._element && this._element.nativeElement && (this._element.nativeElement.style.maxHeight === this.height + 'px' ?
      this._renderer.setStyle(this._element.nativeElement, 'max-height', this._element.nativeElement.scrollHeight + 'px')
      : this._renderer.setStyle(this._element.nativeElement, 'max-height', this.height + 'px'));
  }
}
